import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PDPService } from '@app/app/pdp/pdp/pdp.service';
import { DeviceService, EventTrackerService } from '@app/core';
import { iBook, ProductTypeEnum } from '@app/interfaces/iBook';
import { IndicatorService } from '@app/shared';
import { environment } from '@env/environment';

@Component({
  selector: 'navaar-plp-list-item',
  templateUrl: './plp-list-item.component.html',
  styleUrls: ['./plp-list-item.component.scss']
})
export class PlpListItemComponent implements OnInit, OnChanges, OnDestroy {

  @Input('items') public items: Array<iBook>;
  @Input() public isEnd: boolean = false;
  @Input('disable-when-fetch-data') public isLoading: boolean = false;
  @Input('more-icon') public showIcon;
  @Output('go-to') public goToPage: EventEmitter<number> = new EventEmitter<number>();

  public readonly IMAGE_URL: string = environment.imageUrl;
  public productType: typeof ProductTypeEnum = ProductTypeEnum;
  public contentType;
  constructor(
    private readonly router: Router,
    private readonly eventTracker: EventTrackerService,
    private readonly indicator: IndicatorService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly pdpService: PDPService,
    public readonly device: DeviceService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items?.currentValue.length > 0) {
      if (this.contentType === ProductTypeEnum.Capsule || this.contentType === ProductTypeEnum.Podcast) {
        this.items = this.items.map(z => {
          z['showPlayer'] = false;
          return z;
        });
      }
    }
  }

  public ngOnInit() {
    this.pdpService.statusPlay$.subscribe(z => {
      if (z === false) {
        this.items.forEach(z => z['showPlayer'] = false);
      }
    })
    this.activatedRoute.paramMap.subscribe(() => {
      this.contentType = ProductTypeEnum[this.activatedRoute.snapshot.queryParamMap.get("contentType") as keyof typeof ProductTypeEnum];
      if (this.contentType === ProductTypeEnum.Capsule || this.contentType === ProductTypeEnum.Podcast) {
        this.items = this.items.map(z => {
          z['showPlayer'] = false;
          return z;
        });
      }
    });
  }

  public goToBook(id, idx: number) {
    this.indicator.show();
    this.eventTracker.logEvent('view_item', { item_id: id, item_location_id: 'genre-' + id, x_item_index: idx });
    this.router.navigate(['/audiobook', id]);
  }

  public ngOnDestroy(): void {
    this.indicator.hideHude();
  }

  public playAudioBook(identifierId, item) {
    item.showPlayer = true;
    this.pdpService.setStatusPlayButton(true);
    this.pdpService.playWithIdentifierId(identifierId).then();
  }

  public trackBy(index, item): any {
    return item.identifier;
  }

}
